<template>
    <div>
        <div class="d-flex flex-stack flex-wrap">
            <div class="page-title d-flex flex-column me-3 mt-3">
                <h1 class="d-flex text-gray-800 fw-bolder my-1 fs-3">Update Template
                    <Popper placement="right">
                        <span class="svg-icon svg-icon-muted svg-icon-hx cursor-pointer">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                                <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="currentColor" />
                                <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="currentColor" />
                            </svg>
                        </span>
                    </Popper>
                </h1>
                <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1">
                    <li class="breadcrumb-item text-gray-600">
                        <a href="#" class="text-gray-600 text-hover-primary"><router-link :to="{ name: 'Home' }">Home</router-link></a>
                    </li>
                    <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">Settings</router-link></li>
                    <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'SystemSettings' }">System Settings</router-link></li>
                    <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'BankDataImportTemplates' }">Data Import Templates</router-link></li>
                    <li class="breadcrumb-item text-gray-600">Update Template</li>
                </ul>
            </div>
            <div class="d-flex align-items-center py-1">
                <router-link to="/BankDataImportTemplates">
                    <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                        <span class="ms-2 fs-7"> Return back to List</span>
                    </button>
                </router-link>
            </div>
        </div>
        <div class="content flex-row-fluid mt-4" id="kt_content">
            <div class="card card-xxl-stretch">
                <div class="p-10">
                    <div class="row">
                        <div class="col-lg-12">
                            <table class="table table-rounded table-striped table-bordered border gy-3 gs-3">
                                <tbody>
                                    <tr class="border">
                                        <td class="fw-bold">Category:</td>
                                        <td> 
                                            Bank Transaction
                                        </td>
                                    </tr>
                                    <tr class="border">
                                        <td class="fw-bold">Name:</td>
                                        <td>{{  form.name }}</td>
                                    </tr>
                                    <tr class="border">
                                        <td class="fw-bold">File Type:</td>
                                        <td>
                                            <span v-if="form.file_type_id == 0">Not Selected</span>
                                            <span v-if="form.file_type_id == 1">Excel</span>
                                            <span v-if="form.file_type_id == 2">XML</span>
                                            <span v-if="form.file_type_id == 3">CSV</span> 
                                        </td>
                                    </tr>
                                    <tr class="border">
                                        <td class="fw-bold">Bank:</td>
                                        <td>{{  form.related_account_name }}</td>
                                    </tr>
                                    <tr class="border">
                                        <td class="fw-bold">Description:</td>
                                        <td>{{  form.description }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> 
                    <!-- <div class="separator my-3 mt-0 border-gray-300"></div> -->

                    <!-- WORKSHEET TABS -->
                    <div class="mb-5">
                        <div class="d-grid">
                            <ul class="nav nav-tabs flex-nowrap text-nowrap">
                                <div class="nav-item mt-4 me-3">
                                    <span>
                                        Worksheets: 
                                    </span>
                                </div>
                                <li class="nav-item" v-for="item, index in this.addedWorksheets" v-bind:key="item">
                                    <a :ref="el => { if (el) buttonRefs[index] = el }" :id="'WorksheetTab_' + index"
                                        class="nav-link btn btn-active-light btn-color-gray-600 btn-active-color-primary rounded-bottom-0 border border-gray-200" 
                                        data-bs-toggle="tab" :href="'#kt_tab_pane_ws_' + index"
                                        @click="this.GetExcelDataByRecordID(item.name)">
                                       <strong> {{  item.name }}  </strong>
                                       <small v-if="item.virtual_name !== null && item.virtual_name !== '' && item.virtual_name !== undefined && item.virtual_name !== item.name">({{  item.virtual_name }})</small>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade" :id="'kt_tab_pane_ws_' + index" role="tabpanel" v-for="item, index in this.addedWorksheets" v-bind:key="item">
                            <!-- <div class="card shadow-sm p-1">
                                <div class="card-header">
                                    <h3 class="card-title">{{  item.name }} ({{  item.virtual_name }})</h3>
                                    <div class="card-toolbar">
                                        <button type="button" class="btn btn-sm btn-danger btn-outline">
                                            Scripts
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    {{  item.description }}
                                </div> 
                            </div> -->
                            <div class="table-responsive mt-1">
                                <table class="table table-rounded border gy-4 gs-4 mt-2 text-gray-800">
                                    <thead>
                                        <tr>
                                            <th class="text-center">Selected</th>
                                            <th>Field</th>
                                            <th class="text-center">Data Type</th>
                                            <th class="text-center">Target SQL Field</th>
                                            <!-- <th class="text-center">Keep Original?</th>
                                            <th class="text-center">Is Required?</th>
                                            <th class="text-center">Is Key?</th>
                                            <th class="text-center">Conditions</th>
                                            <th class="text-center">Formulas</th>
                                            <th class="text-center">Descriptions</th> -->
                                        </tr>
                                    </thead>
                                    <tbody v-if="this.excelFields.length > 0">
                                        <tr v-for="item in this.excelFields" v-bind:key="item" :class="{ 'bg-light': !item.isSelected, 'bg-light-success': item.isSelected }">
                                            <td class="align-middle border">
                                                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                                                    <input class="form-check-input" type="checkbox" v-model="item.isSelected" />
                                                </div>
                                            </td>
                                            <td class="align-middle border">
                                                <span class="badge badge-secondary me-2 p-2 fs-6">
                                                    <strong> {{ item.displayText }} </strong>  
                                                </span>
                                            </td>
                                            <td class="align-middle text-center border">
                                                <span class="badge badge-secondary">
                                                    {{ item.type }}
                                                </span>
                                            </td>
                                            <td class="align-middle border">
                                                <Select2 v-model="item.sqlField" :options="this.sqlFields" :settings="{ width: '100%' }" />
                                            </td> 
                                            <!-- <td class="align-middle border">
                                                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                                                    <input class="form-check-input" type="checkbox" :v-model="item.id + '_is_keep_' + index" />
                                                </div>
                                            </td>
                                            <td class="align-middle border">
                                                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                                                    <input class="form-check-input" type="checkbox" :v-model="item.id + '_is_required_' + index" />
                                                </div>
                                            </td>
                                            <td class="align-middle border">
                                                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                                                    <input class="form-check-input" type="checkbox" :v-model="item.id + '_is_key_' + index" />
                                                </div>
                                            </td>
                                            <td class="align-middle border text-center">
                                                <a href="#" class="btn btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary btn-sm" data-bs-toggle="modal" data-bs-target="#OpenConditionsModal" @click="openConditionsModal(item)">
                                                    <i class="fa fa fa-map-signs text-primary"></i> 
                                                    Conditions
                                                </a>
                                            </td>
                                            <td class="align-middle border text-center">
                                                <a href="#" class="btn btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btn-sm" data-bs-toggle="modal" data-bs-target="#OpenFormulasModal" @click="openFormulasModal(item)">
                                                    <i class="fa fa-vial text-info"></i>
                                                    Formulas
                                                </a>
                                            </td>  
                                            <td class="align-middle border text-center">
                                                <a href="#" class="btn btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark btn-sm" data-bs-toggle="modal" data-bs-target="#OpenDescriptionsModal" @click="openDescriptionsModal(item)">
                                                    <i class="fa fa-align-left text-gray-800"></i>
                                                    Descriptions
                                                </a>
                                            </td> -->
                                        </tr>
                                        <!-- <tr>
                                            <td colspan="4" class="align-middle text-end">
                                                <button class="btn btn-sm btn-wide btn-secondary" @click="onInsertNewRow()"> <i class="fas fa-plus"></i> Insert Custom Field </button>
                                            </td>
                                            <td colspan="5" class="align-middle text-start">
                                                <button class="btn btn-sm btn-wide btn-secondary" @click="onInsertNewRelationRow()"> <i class="fas fa-plus"></i> Insert Relational Field </button>
                                            </td>
                                        </tr>  -->
                                    </tbody>
                                </table> 
                            </div>
                            <!-- <div class="table-responsive mt-3" v-if="this.customExcelFields.length > 0"> 
                                <table class="table table-rounded table-striped border gy-7 gs-7 table-hover">
                                    <thead style="background-color: #FFFDE7;">
                                        <tr>
                                            <th>Custom Field Name</th>
                                            <th>Target SQL Field</th>
                                            <th>Target Data Type</th>
                                            <th>Is Required?</th>
                                            <th>Is Key?</th>
                                            <th>Conditions</th>
                                            <th>Formula</th>
                                            <th>Script</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in this.customExcelFields" v-bind:key="item">
                                            <td class="align-middle">
                                                <input type="text" class="form-control form-control-sm" />
                                            </td>
                                            <td class="align-middle">
                                                <Select2 :v-model="item + '_' + index" :options="this.sqlFields" :settings="{ width: '100%' }" />
                                            </td> 
                                            <td class="align-middle">
                                                <Select2 :v-model="item + '_data_type_' + index" :options="this.dataTypes" :settings="{ width: '100%' }" />
                                            </td> 
                                            <td class="align-middle">
                                                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                                                    <input class="form-check-input" type="checkbox" :v-model="item.id + '_is_required_' + index" />
                                                </div>
                                            </td>
                                            <td class="align-middle">
                                                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                                                    <input class="form-check-input" type="checkbox" :v-model="item.id + '_is_key_' + index" />
                                                </div>
                                            </td>
                                            <td class="align-middle">
                                                <a href="#" class="btn btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary btn-sm" data-bs-toggle="modal" data-bs-target="#OpenConditionsModal" @click="openConditionsModal()">
                                                    <i class="fa fa fa-map-signs text-primary"></i> 
                                                    Conditions
                                                </a>
                                            </td>
                                            <td class="align-middle">
                                                <a href="#" class="btn btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btn-sm" data-bs-toggle="modal" data-bs-target="#OpenFormulasModal" @click="openFormulasModal()">
                                                    <i class="fa fa-vial text-info"></i>
                                                    Formulas
                                                </a>
                                            </td> 
                                            <td class="align-middle">
                                                <a href="#" class="btn btn-outline btn-outline-dashed btn-outline-danger btn-active-light-danger btn-sm" data-bs-toggle="modal" data-bs-target="#OpenScriptModal" @click="openScriptsModal()">
                                                    <i class="fa fa-scroll text-danger"></i>
                                                    Scripts
                                                </a>
                                            </td>
                                            <td class="align-middle">
                                                <a href="#" class="btn btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark btn-sm" data-bs-toggle="modal" data-bs-target="#OpenDescriptionsModal" @click="openDescriptionsModal()">
                                                    <i class="fa fa-align-left text-gray-800"></i>
                                                    Descriptions
                                                </a>
                                            </td>
                                        </tr> 
                                    </tbody>
                                </table> 
                            </div>
                            <div class="table-responsive mt-3" v-if="this.customRelationalFields.length > 0"> 
                                <table class="table table-rounded table-striped border gy-7 gs-7 table-hover">
                                    <thead style="background-color: #FFEBEE;">
                                        <tr>
                                            <th>Relational Field Name</th>
                                            <th>Target SQL Field</th>
                                            <th>Target Data Type</th>
                                            <th>Is Required?</th>
                                            <th>Is Key?</th>
                                            <th>Conditions</th>
                                            <th>Formula</th>
                                            <th>Script</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in this.customRelationalFields" v-bind:key="item">
                                            <td class="align-middle">
                                                <input type="text" class="form-control form-control-sm" />
                                            </td>
                                            <td class="align-middle">
                                                <Select2 :v-model="item + '_' + index" :options="this.sqlFields" :settings="{ width: '100%' }" />
                                            </td> 
                                            <td class="align-middle">
                                                <Select2 :v-model="item + '_data_type_' + index" :options="this.dataTypes" :settings="{ width: '100%' }" />
                                            </td> 
                                            <td class="align-middle">
                                                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                                                    <input class="form-check-input" type="checkbox" :v-model="item.id + '_is_required_' + index" />
                                                </div>
                                            </td>
                                            <td class="align-middle">
                                                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                                                    <input class="form-check-input" type="checkbox" :v-model="item.id + '_is_key_' + index" />
                                                </div>
                                            </td>
                                            <td class="align-middle">
                                                <a href="#" class="btn btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary btn-sm" data-bs-toggle="modal" data-bs-target="#OpenConditionsModal" @click="openConditionsModal()">
                                                    <i class="fa fa fa-map-signs text-primary"></i> 
                                                    Conditions
                                                </a>
                                            </td>
                                            <td class="align-middle">
                                                <a href="#" class="btn btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btn-sm" data-bs-toggle="modal" data-bs-target="#OpenFormulasModal" @click="openFormulasModal()">
                                                    <i class="fa fa-vial text-info"></i>
                                                    Formulas
                                                </a>
                                            </td> 
                                            <td class="align-middle">
                                                <a href="#" class="btn btn-outline btn-outline-dashed btn-outline-danger btn-active-light-danger btn-sm" data-bs-toggle="modal" data-bs-target="#OpenScriptModal" @click="openScriptsModal()">
                                                    <i class="fa fa-scroll text-danger"></i>
                                                    Scripts
                                                </a>
                                            </td>
                                            <td class="align-middle">
                                                <a href="#" class="btn btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark btn-sm" data-bs-toggle="modal" data-bs-target="#OpenDescriptionsModal" @click="openDescriptionsModal()">
                                                    <i class="fa fa-align-left text-gray-800"></i>
                                                    Descriptions
                                                </a>
                                            </td>
                                        </tr> 
                                    </tbody>
                                </table> 
                            </div> -->
                            <div class="col-lg-12 mt-5">
                                <button class="btn btn-lg btn-success w-100" @click="onSaveExcelSettings()">
                                    <span class="svg-icon svg-icon-2">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                        <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                        </svg>
                                    </span> 
                                    SAVE EXCEL SETTINGS
                                </button>
                            </div>
                        </div> 
                    </div> 
                    
                    <!-- MODALS -->
                    <!-- <div class="modal fade" tabindex="-1" id="OpenScriptModal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Scripts</h5>
                                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                                        aria-label="Close">
                                        <span class="svg-icon svg-icon-2x"></span>
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <div class="card">
                                        <div class="card-body">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="modal fade" tabindex="-1" id="OpenConditionsModal">
                        <div class="modal-dialog modal-xl">
                            <div class="modal-content">
                                <div class="modal-header bg-primary">
                                    <h5 class="modal-title text-white">Conditions</h5> 
                                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                                        <i class="text-white fa fa-times mt-1 fs-1 text-hover-primary"><span class="path1"></span><span class="path2"></span></i>
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="alert bg-light-primary d-flex flex-column flex-sm-row w-100 p-5 mb-3">
                                                <div class="d-flex flex-column">
                                                    <span class="fs-4">
                                                        <span class="svg-icon svg-icon-primary svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path opacity="0.3" d="M18 22C19.7 22 21 20.7 21 19C21 18.5 20.9 18.1 20.7 17.7L15.3 6.30005C15.1 5.90005 15 5.5 15 5C15 3.3 16.3 2 18 2H6C4.3 2 3 3.3 3 5C3 5.5 3.1 5.90005 3.3 6.30005L8.7 17.7C8.9 18.1 9 18.5 9 19C9 20.7 7.7 22 6 22H18Z" fill="currentColor"/>
                                                        <path d="M18 2C19.7 2 21 3.3 21 5H9C9 3.3 7.7 2 6 2H18Z" fill="currentColor"/>
                                                        <path d="M9 19C9 20.7 7.7 22 6 22C4.3 22 3 20.7 3 19H9Z" fill="currentColor"/>
                                                        </svg>
                                                        </span>
                                                        &nbsp;
                                                        <strong> {{  this.selectedColumn.displayText  }} </strong> column will only be imported if it meets the conditions specified below.
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="d-grid gap-2 mb-2">
                                                <button type="button" class="btn btn-secondary my-3" @click="onAddNewBlock()"> <i class="fa fa-plus"></i> ADD IF-THEN BLOCK </button>
                                            </div> 
                                        <div v-for="blockItem, blockIndex in this.blocks" v-bind:key="blockItem">
                                            <div class="card border border-gray-400 mb-5">
                                                <div class="card-header bg-light-primary">
                                                    <h3 class="card-title">
                                                        <strong>IF </strong> <br><br>
                                                    </h3>
                                                    <div class="card-toolbar">
                                                       <button type="button" class="btn btn-xs btn-light-danger" @click="onRemoveBlock(blockItem)">
                                                            Delete Block
                                                       </button>
                                                        &nbsp;
                                                        #{{  blockIndex + 1 }}
                                                    </div> 
                                                </div>
                                                <div class="card-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr class="fw-bold fs-6 text-gray-800">
                                                                    <th>Option 1</th>
                                                                    <th>Operator</th>
                                                                    <th>Option 2</th>
                                                                    <th>Add</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <Select2 v-model="blockItem.conditionForm.option_1" :options="this.conditionFields" :settings="{ width: '100%' }" />
                                                                        <input type="text" placeholder="Insert Custom Value here..." v-model="blockItem.conditionForm.custom_option_1" class="form-control form-control-sm mt-2" v-if="blockItem.conditionForm.option_1 == 'CUSTOM'"/>
                                                                    </td>
                                                                    <td>
                                                                        <Select2 v-model="blockItem.conditionForm.operator_value" :options="this.operator_values" :settings="{ width: '100%' }" />
                                                                    </td>
                                                                    <td>
                                                                        <Select2 v-model="blockItem.conditionForm.option_2" :options="this.conditionFields" :settings="{ width: '100%' }" />
                                                                        <input type="text" placeholder="Insert Custom Value here..." v-model="blockItem.conditionForm.custom_option_2" class="form-control form-control-sm mt-2"  v-if="blockItem.conditionForm.option_2 == 'CUSTOM'"/>
                                                                    </td>
                                                                    <td>
                                                                        <button class="btn btn-icon btn-success" @click="onAddIfCondition(blockItem)">
                                                                            <i class="fa fa-plus"></i>
                                                                        </button>
                                                                    </td> 
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div class="table-responsive">
                                                        <table class="table table-rounded table-striped border gy-2 gs-2">
                                                            <thead>
                                                                <tr class="fw-semibold fs-6 text-gray-800 border-bottom border-gray-200">
                                                                    <th>#</th>
                                                                    <th>Option 1</th>
                                                                    <th>Operator</th>
                                                                    <th>Option 2</th>
                                                                    <th class="text-end">Remove</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody> 
                                                                <tr v-for="item, index in blockItem.conditions" v-bind:key="item">
                                                                    <td class="align-middle fs-6">
                                                                        Condition: {{ index + 1 }}:
                                                                    </td>
                                                                    <td class="align-middle fs-5">
                                                                        <strong v-if="item.option_1 != 'CUSTOM'"> 
                                                                            {{  getConditionName(item.option_1)  }}
                                                                        </strong>
                                                                        <strong v-if="item.option_1 == 'CUSTOM'">
                                                                            {{  item.custom_option_1  }}
                                                                        </strong>
                                                                    </td>
                                                                    <td class="align-middle fs-3">
                                                                        <strong>
                                                                            {{  item.operator_value  }}
                                                                        </strong>
                                                                    </td>
                                                                    <td class="align-middle fs-5">
                                                                        <strong v-if="item.option_2 != 'CUSTOM'"> 
                                                                            {{  item.option_2  }}
                                                                        </strong>
                                                                        <strong v-if="item.option_2 == 'CUSTOM'">
                                                                            {{  item.custom_option_2  }}
                                                                        </strong>
                                                                    </td>
                                                                    <td class="text-end"> 
                                                                        <button class="btn btn-sm btn-icon btn-light-danger" @click="onRemoveCondition(item)">
                                                                            <i class="fa fa-times"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr> 
                                                            </tbody>  
                                                        </table>
                                                        <div> 
                                                            <div class="alert alert-dismissible bg-light-primary d-flex flex-column flex-sm-row w-100 p-5 mb-1" v-if="blockItem.conditions.length > 0">
                                                                <div class="d-flex flex-column pe-0 pe-sm-10">
                                                                    <h4 class="fw-semibold mb-3">IF Summary:</h4>
                                                                    <span>
                                                                        <ul v-for="item in blockItem.conditions" v-bind:key="item"> 
                                                                            <li class="fs-6 text-left">
                                                                                <strong> 
                                                                                    <code>{{  getConditionName(item.option_1) }}</code>
                                                                                </strong>
                                                                                should be
                                                                                <span class="fw-bolder" v-if="item.operator_value == '>='"> Greater Than or Equal to </span>
                                                                                <span class="fw-bolder" v-if="item.operator_value == '<='"> Less Than or Equal to </span>
                                                                                <span class="fw-bolder" v-if="item.operator_value == '=='"> Equal to </span>
                                                                                <span class="fw-bolder" v-if="item.operator_value == '!='"> Not Equal </span>
                                                                                <span class="fw-bolder" v-if="item.operator_value == '<'"> Less Than </span>
                                                                                <span class="fw-bolder" v-if="item.operator_value == '>'"> Greater Than </span>
                                                                                <span class="fw-bolder" v-if="item.operator_value == 'OR'"> Or </span>
                                                                                <span class="fw-bolder" v-if="item.operator_value == 'BETWEEN'"> Between </span>
                                                                                <span class="fw-bolder" v-if="item.operator_value == 'NOT'"> Not </span>
                                                                                <strong> 
                                                                                   <code>{{ getConditionName(item.option_2) }}</code>
                                                                                </strong>
                                                                            </li> 
                                                                        </ul> 
                                                                    </span>
                                                                </div> 
                                                            </div> 
                                                        </div> 
                                                    </div>
                                                </div>
                                                <div class="card-header bg-light-info border border-1 border-gray-300">
                                                    <h3 class="card-title"><strong>THEN </strong></h3>
                                                </div>
                                                <div class="card-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr class="fw-bold fs-6 text-gray-800">
                                                                    <th>Value</th>
                                                                    <th>Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <Select2 v-model="blockItem.then_value" :options="this.thenFields" :settings="{ width: '100%' , dropdownParent: '#OpenConditionsModal .modal-content' }" @select="onChangeThenValue(blockItem)"/>
                                                                        <input type="text" placeholder="Insert Custom Value here..." v-model="blockItem.then_value_custom" class="form-control form-control-sm mt-2" v-if="blockItem.then_value == 'SAVE CUSTOM VALUE'"/>
                                                                    </td>
                                                                    <td>
                                                                        <button class="btn btn-success" @click="onSaveThenCondition(blockItem)">
                                                                            <i class="fa fa-check"></i> Save Result
                                                                        </button>
                                                                    </td> 
                                                                </tr>
                                                                <tr v-if="blockItem.then_value != 'SELECT AN OPTION'">
                                                                    <td colspan="2">
                                                                        <code>
                                                                            {{ blockItem.then_value }} {{ blockItem.then_value_custom }}
                                                                        </code>
                                                                        condition will be applied as a result.
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div> 
                                            <div class="separator separator-content my-7" v-if="this.blocks.length > 1 && this.blocks.length != ( blockIndex+1 )"> OR </div>
                                        </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="modal fade" tabindex="-1" id="OpenFormulasModal">
                        <div class="modal-dialog modal-xl">
                            <div class="modal-content">
                                <div class="modal-header bg-info">
                                    <h5 class="modal-title text-white">Formulas</h5>
                                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                                        <i class="text-white fa fa-times mt-1 fs-1 text-hover-primary"><span class="path1"></span><span class="path2"></span></i>
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="alert bg-light-info d-flex flex-column flex-sm-row w-100 p-5 mb-10">
                                                <div class="d-flex flex-column">
                                                    <span class="fs-4">
                                                        <span class="svg-icon svg-icon-info svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path opacity="0.3" d="M18 22C19.7 22 21 20.7 21 19C21 18.5 20.9 18.1 20.7 17.7L15.3 6.30005C15.1 5.90005 15 5.5 15 5C15 3.3 16.3 2 18 2H6C4.3 2 3 3.3 3 5C3 5.5 3.1 5.90005 3.3 6.30005L8.7 17.7C8.9 18.1 9 18.5 9 19C9 20.7 7.7 22 6 22H18Z" fill="currentColor"/>
                                                        <path d="M18 2C19.7 2 21 3.3 21 5H9C9 3.3 7.7 2 6 2H18Z" fill="currentColor"/>
                                                        <path d="M9 19C9 20.7 7.7 22 6 22C4.3 22 3 20.7 3 19H9Z" fill="currentColor"/>
                                                        </svg>
                                                        </span>
                                                        &nbsp;
                                                        You can apply Formulas to <strong> {{  this.selectedColumn.displayText  }} </strong> on this screen.
                                                    </span>
                                                </div>
                                            </div>
                                            <textarea class="form-control" rows="9"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
<!-- 
                    <div class="modal fade" tabindex="-1" id="OpenDescriptionsModal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header bg-dark">
                                    <h5 class="modal-title">Descriptions</h5>
                                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                                        aria-label="Close">
                                        <span class="svg-icon svg-icon-2x"></span>
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <div class="card">
                                        <div class="card-body">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <!-- FILE UPLOAD: XML -->    
                    <!-- <div class="col-lg-12 mt-7" v-if="this.form.file_type_id == 2"> 
                        <label class="fs-6 fw-bold form-label mt-3">
                            Upload XML File
                        </label>
                        <input type="file" id="input" class="form-control form-control-lg input-lg" @change="onXMLFileChange" ref="xmlFile"/>
                    </div>

                    <div class="col-lg-12 mt-3">
                        <div class="d-grid gap-2">
                            <button type="button" class="btn btn-lg btn-primary " @click="this.updateTemplate()" data-kt-indicator="on">
                                <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                </svg>
                                </span>
                            <strong v-if="!this.isProgressing"> Update Template</strong>
                            <span class="indicator-progress" v-if="this.isProgressing"> Saving... <span
                                    class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                        </div>
                    </div> -->
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'; 
export default {
  name: "DesignBankImportTemplate",
  data() {
    return {
        sourceList: [],
        form: { 
            category_id: 6,
            source: 1,
            clone_template: 0,
            description: null,
            file_type_id: 0
        },
        categoryList: [
            { id: 0, text: 'Select an option'},
            { id: 1, text: 'Accounts'},
            { id: 2, text: 'Bank Statement'},
            { id: 5, text: 'Collection'},
            { id: 3, text: 'Insurance Policy'},
            { id: 4, text: 'Invoice'},
            { id: 6, text: 'Bank Transaction' }
        ],
        sqlFields: [],
        dataTypes: [ 'None', 'Boolean' ,'Text' ,'Numeric' ,'DateTime' ,'Unknown' ],
        sheetNames: [],
        excelFields: [],
        excelContent: [],
        excelColumns: [],
        customExcelFields: [],
        fileSourceTypeList: [
            { id: 1, text: 'Excel File' },
            { id: 2, text: 'XML File' }
        ],
        targetDatasetList: [
            { id: 0, text: 'SELECT DATASET' },
            { id: 1, text: 'Accounts' },
            { id: 2, text: 'Invoices' },
            { id: 3, text: 'Transactions' },
            { id: 4, text: 'Policies' }
        ],
        customRelationalFields: [],
        addedWorksheets: [],
        operator_values: [ 'SELECT AN OPERATOR', '>=', '<=', '==' , '!=', '<' ,'>' ,'OR' ,'BETWEEN' ],
        conditionFields: [],
        selectedColumn: { id: null, displayText: null },
        conditions: [],
        blocks: [],
        thenFields:[ 'SELECT AN OPTION', 'SAVE CUSTOM VALUE', 'SAVE VALUE', 'DO NOT SAVE VALUE' ],
        buttonRefs: []
    };
  },
  computed: {
        getConditionName() { 
            return (value)=>{
                if (value) {
                    var dataFound = this.excelFields.find(item =>item.id == value );
                    if(dataFound){
                        return dataFound.displayText;
                    } 
                    else{
                        if(value){
                            return value;
                        }
                        return null;
                    }
                }
            }
        }
  },
  methods: {
    onGetTemplate(){
        const params = {
            session_id: this.$getUser().session_id,
            id: this.$getSessionStorage('record_id')
        };
        axios.post('api/Office/GetDataImportTemplateById', params, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){      
                this.form = response.data;
                this.onGetWorksheetParametersFromDB();
            }
        });
    },
    updateTemplate() {
      this.$swal("Success", "Template update succesfully..!", 'success');
      this.$router.replace('/UpdateImportTemplate');
    },
    GetExcelDataByRecordID(sheetName){
      const params = {
        worksheet_name: sheetName,
        workbook_name: this.fileName,
        session_id: this.$getUser().session_id,
        file_type_id: this.form.file_type_id,
        record_id: this.$getSessionStorage('record_id')
      };    
      axios.post('/api/Office/GetExcelData', params, {'Content-Type': 'application/json'})
        .then((response) => { 
          this.excelContent = response.data.content;
          this.excelColumns = response.data.columns;
          this.excelFields = response.data.fields;
        })
        .catch(function (error) {
            console.error(error);
        }); 
    },
    onInsertNewRow(){
        this.customExcelFields.push(
            {
                id: Math.random()
            }
        );
    },
    openScriptsModal(){

    },
    openConditionsModal(selectedColumn){
        this.blocks = [];
        this.selectedColumn = selectedColumn;
        this.conditionFields = [];
        this.excelFields.forEach(element => {
            element['text'] = element.displayText; 
            this.conditionFields.push(element);
        });
        this.conditionFields.unshift({
            id: 'CUSTOM',
            text: 'CUSTOM VALUE'
        });
        this.conditionFields.unshift({
            id: -1,
            text: 'SELECT A FIELD'
        });

        const params = {
            parameter_id: selectedColumn.id
        };    
        axios.post('/api/Office/GetConditionBlocks', params, {'Content-Type': 'application/json'})
        .then((response) => {
            response.data.forEach(item => {
                this.blocks.push({
                    id: item.id,
                    parameter_id: item.parameter_id,
                    conditions: item.conditions,
                    then_value: item.then_value,
                    then_value_custom: item.then_value_custom,
                    conditionForm: {
                        option_1: -1,
                        option_2: -1,
                        custom_option_1: null,
                        custom_option_2: null,
                        operator_value: 'SELECT AN OPERATOR'
                    }
                });
            }); 
        })
        .catch(function (error) {
            console.error(error);
        }); 
    },
    onAddIfCondition(blockItem){
        var option1 = blockItem.conditionForm.option_1 == 'CUSTOM' ? blockItem.conditionForm.custom_option_1 : blockItem.conditionForm.option_1;
        var option2 = blockItem.conditionForm.option_2 == 'CUSTOM' ? blockItem.conditionForm.custom_option_2 : blockItem.conditionForm.option_2;
        const params = {
            option_1: option1,
            option_2: option2,
            operator_value: blockItem.conditionForm.operator_value,
            block_id: blockItem.id
        };    
        axios.post('/api/Office/CreateConditions', params, {'Content-Type': 'application/json'})
        .then(() => { 

            blockItem.conditions.push(params);
            blockItem.conditionForm = {
                option_1: -1,
                option_2: -1,
                custom_option_1: null,
                custom_option_2: null,
                operator_value: 'SELECT AN OPERATOR'
            };

            this.$swal("Success", "IF condition saved!", 'success');
        })
        .catch(function (error) {
            console.error(error);
        }); 
    },
    onSaveThenCondition(blockItem){
        const params = {
            id: blockItem.id, 
            then_value: blockItem.then_value,
            then_value_custom: blockItem.then_value_custom
        };    
        axios.post('/api/Office/UpdateConditionBlocks', params, {'Content-Type': 'application/json'})
        .then(() => { 
            this.$swal("Success", "THEN condition saved!", 'success');
        })
        .catch(function (error) {
            console.error(error);
        });  
    },
    openFormulasModal(selectedColumn){
        this.selectedColumn = selectedColumn;
    },
    openDescriptionsModal(){

    },
    onInsertNewRelationRow(){
        this.customRelationalFields.push(
            {
                id: Math.random()
            }
        );
    },
    getXMLKeys(json_object, ret_array = []){
        for (var json_key in json_object) {
            if (typeof(json_object[json_key]) === 'object' && !Array.isArray(json_object[json_key])) {
                ret_array.push(json_key);
                this.getXMLKeys(json_object[json_key], ret_array);
            } else if (Array.isArray(json_object[json_key])) {
                ret_array.push(json_key);
                var first_element = json_object[json_key][0];
                if (typeof(first_element) === 'object') {
                    this.getXMLKeys(first_element, ret_array);
                }
            } else {
                ret_array.push(json_key);
            }
        }

        return ret_array
    },
    onXMLFileChange(event){
        const formData = new FormData();
            formData.append('file', event.target.files[0]);
            this.fileName = event.target.files[0].name;
            fetch('/api/Office/GetXMLContent', {
                method: 'POST',
                body: formData,
                headers: {}
            }).then(response => response.json())
              .then(data => {
                // JSON Parse
                var allNodes = [];
                this.getXMLKeys(data, allNodes);
              });
    },
    onGetWorksheetParametersFromDB(){
        const parameters = {
            session_id: this.$getUser().session_id,
            template_id: this.$getSessionStorage('record_id')
        };        
        const requestOne =  axios.post('/api/Office/GetWorksheetParameters', parameters, {'Content-Type': 'application/json'});
        const requestTwo =  axios.post('/api/Office/GetFields', parameters, {'Content-Type': 'application/json'});        
        axios.all([requestOne, requestTwo]).then(axios.spread((...responses) => {
            this.addedWorksheets = responses[0].data;
            this.sqlFields = responses[1].data;
            if(this.addedWorksheets.length > 0) {
                this.GetExcelDataByRecordID(this.addedWorksheets[0].name);                
                setTimeout(() => {
                    this.buttonRefs[0]?.click();
                }, 500);
            }
        }))
        .catch(errors => { 
            console.error(errors); 
        }); 
    },
    onAddNewBlock(){ 
        this.blocks = [];
        const params = {
            parameter_id: this.selectedColumn.id
        };    
        axios.post('/api/Office/CreateConditionBlocks', params, {'Content-Type': 'application/json'})
            .then((response) => { 
                 response.data.forEach(item => {
                        this.blocks.push({
                            id: item.id,
                            parameter_id: item.parameter_id,
                            then_value: 'SELECT AN OPTION',
                            then_value_custom: null,
                            conditions: item.conditions,
                            conditionForm: {
                                option_1: -1,
                                option_2: -1,
                                custom_option_1: null,
                                custom_option_2: null,
                                operator_value: 'SELECT AN OPERATOR'
                            }
                        });
                }); 
            })
            .catch(function (error) {
                console.error(error);
            });  
    },
    onRemoveCondition(item){
        this.$swal.fire({
            title: "Are you sure you want to delete this condition?",
            confirmButtonColor: "#f1416c",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "DELETE CONDITION",
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {
                const params = {
                    id: item.id,
                    block_id: item.block_id
                };    
                axios.post('/api/Office/DeleteConditions', params, {'Content-Type': 'application/json'})
                    .then(() => { 
                        this.blocks.forEach(blockItem => {
                            if(blockItem.id == item.block_id){
                                const index = blockItem.conditions.indexOf(item);
                                blockItem.conditions.splice(index, 1);
                            }
                        });
                    })
                    .catch(function (error) {
                        console.error(error);
                    });
            }
        });
    },
    onChangeThenValue(blockItem){
        // 'SELECT AN OPTION', 'SAVE CUSTOM VALUE', 'SAVE VALUE', 'DO NOT SAVE VALUE'
        if(blockItem.then_value == 'SELECT AN OPTION' || 
           blockItem.then_value == 'SAVE CUSTOM VALUE' || 
           blockItem.then_value == 'SAVE VALUE' || 
           blockItem.then_value == 'DO NOT SAVE VALUE'){
            blockItem.then_value_custom = null;
        }
    },
    onRemoveBlock(blockItem){
         this.$swal.fire({
            title: "Are you sure you want to delete this block? This will delete all conditions related to this block!",
            confirmButtonColor: "#f1416c",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "DELETE BLOCK",
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {
                const params = {
                    id: blockItem.id,
                    parameter_id: this.selectedColumn.id
                };    
                axios.post('/api/Office/DeleteConditionBlocks', params, {'Content-Type': 'application/json'})
                    .then((response) => { 
                          this.blocks = [];
                          response.data.forEach(item => {
                                this.blocks.push({
                                    id: item.id,
                                    parameter_id: item.parameter_id,
                                    then_value: 'SELECT AN OPTION',
                                    then_value_custom: null,
                                    conditions: item.conditions,
                                    conditionForm: {
                                        option_1: -1,
                                        option_2: -1,
                                        custom_option_1: null,
                                        custom_option_2: null,
                                        operator_value: 'SELECT AN OPERATOR'
                                    }
                                });
                        }); 
                    })
                    .catch(function (error) {
                        console.error(error);
                    });
            }
        });
    },
    onSaveExcelSettings(){
        const fields = [];
        this.excelFields.forEach(element => {
            fields.push({
                id: element.id,
                columnOrder: parseInt(element.columnOrder),
                sqlField: element.sqlField,
                isSelected: element.isSelected ? 1 : 0
            })
        });
        const parameters = {
            session_id : this.$getUser().session_id,
            template_parameter_id: this.$getSessionStorage('record_id'),
            fields: fields
        };
        axios.post('/api/Office/UpdateExcelField', parameters, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                this.$swal("Success", "Data saved succesfully..!", 'success');
            }
        })
        .catch(function (error) {
            console.error(error);
        });
    },
  },
  created(){
    this.onGetTemplate();
  }
}; 
</script>